
const moduleData = {
  id: "module-3",
  title: "Module 3",
  subtitle: "Necessity of Guru in man’s journey to Divinity",
   cardImage: "/enBanner/m3_banner.jpg",
  pdfPath: "/en/Modules/m3.pdf",
  audio: {
    title: "Vedic Chanting - Placeholder",
    audioUrl: "/en/Audio/m3.mp3",
    duration: "0:00"
  },
  video: {
    id: "s-y_2_Q-2_Q"
  },
  hero: {
    title: "Module 3",
    subtitle: "Necessity of Guru in man’s journey to Divinity",
    description: "Content for this module is coming soon.",
    buttonText: "Explore",
    bgImage: "/enBanner/m3_banner.jpg",
    bgAlt: "Placeholder"
  },
  pages: [
    {
      pageId: 'definition',
      title: 'Definition',
      definition: {
        sectionLabel: "Definition",
        title: "What is Necessity of Guru in man’s journey to Divinity?",
        text: "Placeholder text.",
        quote: {
          sanskrit: "",
          meaning: "",
          origin: ""
        },
        description: "Placeholder description.",
        source: "",
        image: "",
        imageAlt: ""
      }
    },
    {
      pageId: 'quiz',
      title: 'Quiz',
      quiz: {
        questions: [
         
        ]
      }
    },
    {
      pageId: 'feedback',
      title: 'Feedback',
      feedback: {}
    }
  ]
};

export { moduleData };
